<template>
  <main v-if="post">
    <section>
      <div class="h2">
        <nuxt-link to="/updates?type=comics">
          Обновления Комиксов манга
        </nuxt-link>
      </div>

      <div class="slider comics">
        <ul :style="`width: ${comics_updates.length * 350}px`">
          <li v-for="item in comics_updates" :key="`comics-update-post-${item.date}`">
            <div class="post-body">
              <div class="poster">
                <img :data-src="item.poster" src="/static_files/no-poster.png" :alt="item.title" class="lazyload">
              </div>
              <div class="post-info">
                <strong v-if="item.title.length > 50">{{ item.title.slice(0, 50) }}...</strong>
                <strong v-else>{{ item.title }}</strong>
                <span v-if="item.update">{{ item.update }}</span>
              </div>
              <nuxt-link :to='`/comics/${postUrl(item.id, item.title)}`'>
                {{ item.title }}
              </nuxt-link>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="comics">
      <!-- <div v-show="turnOffValue" class="turnoff" /> -->

      <nuxt-link to="/comics" class="backlink">Каталог комиксов</nuxt-link>

      <article class="comics-item">
        <div class="content pg">
          <header>
            <div>
              <div class="poster">
                <fav-component :fav="post" />
                <img :src="post.poster" :alt="`Постер к комиксу ${post.title}`" />
              </div>
              <div v-if="user" class="read">
                <a :href="`/comics/${post.id}/chapter/0`">
                  Начать читать
                </a>
              </div>
              <div v-else class="read">
                <a v-if="!isBlocked" :href="`/comics/${post.id}/chapter/0`">
                  Начать читать
                </a>
                <span v-else>
                  Лицензировано
                </span>
              </div>
              <!-- <nuxt-link :to="`/comics/${post.id}/chapter/0`" class="read" tag="div">
                Начать читать
              </nuxt-link> -->
            </div>

            <div class="info">
              <span class="category">{{ post.category }}</span>
              <span
                v-if="post.status"
                :class="{
                  green: typeof post.status === 'string' ? post.status.trim() === 'Продолжается' : '',
                  red: typeof post.status === 'string' ? post.status.trim() === 'Завершен' : ''
                }"
                class="status"
              >{{ post.status }}</span>
              <ul v-if="post.genres && post.genres.length" class="genres">
                <li>
                  <nuxt-link v-if="post.year" :to='`/comics?year=${post.year}`' class="year">{{ post.year }}</nuxt-link>
                </li>
                <li v-for="g in post.genres" :key="`post-genre-${g}`">
                  <nuxt-link :to='`/comics?genre=${g}`'>{{ g }}</nuxt-link>
                </li>
              </ul>
              <h1>{{ post.title }}</h1>

              <div>
                <strong v-if="post.author.length">Авторы:</strong>
                <ul v-if="post.author.length" class="author">
                  <li v-for="a in post.author" :key="`post-author-${a}`">
                    <nuxt-link :to='`/comics?author=${a}`'>{{ a }}</nuxt-link>
                  </li>
                </ul>
                <strong v-if="post.translation.length">Перевод:</strong>
                <ul v-if="post.translation.length" class="translation">
                  <li v-for="t in post.translation" :key="`post-translation-${t}`">
                    <nuxt-link :to='`/comics?translation=${t}`'>{{ t }}</nuxt-link>
                  </li>
                </ul>
              </div>
            </div>
          </header>
        
          <div class="body">
            <p class="desc">{{ post.desc }}</p>
            <p v-if="post.update" class="update">{{ post.update }}</p>

            <h5 v-if="isBlocked" style="margin-top:30px;">Главы удалены из публичного доступа по просьбе правообладателя. Добавьте комикс в Списки (Избранное) чтобы не потерять и следить за обновлениями.</h5>
          </div>
        </div>

        <reaction-component :item="{ id: post._id, reactions: post.reactions, owner_id: null }" />
        <span @click="goToComments" class="go-to-comments">Комментировать</span>
        <share-component :page="{ link: fullPath, button: false }" />
      </article>

      <div style="margin:20px 0px;">
        <div id="yandex_rtb_R-A-1202748-6"></div>
      </div>

      <!-- <adSense v-if="showAdsGlobal" />
      <div id="adfox_165003177429817706" style="text-align:center;margin:20px 0px;"></div> -->

      <!-- <premium-component v-if="showPremiumValue" style="margin-top:30px;" /> -->

      <div v-if="!turnOffValue && !isBlocked">
        <div v-if="post.parts && post.parts.length" onlick="event.stopPropagation()" class="parts">
          <div class="h4">Выберите главу для чтения</div>
          <p class="hint">
            На загрузку Главы может потребоваться некоторое время (~5 секунд).
            Повторное чтение ускоряет отображение изображений Глав.
            Пожалуйста, дождитесь окончания загрузки.
          </p>
          <!-- :class="{ active: index === partIndex }" -->
          <ul class="chapters">
            <nuxt-link :to="`/comics/${post.id}/chapter/${index}`"
              v-for="(part, index) in post.parts.slice(0, showPartsIndex)"
              :key="`chapter-${index}`"
              tag="li"
            >
              <strong>
                {{ part.title }}
                <!-- <i class="icon-loader" /> -->
              </strong>
            </nuxt-link>
          </ul>
          <div v-if="post.parts.length > 18 && showPartsIndex === 18" @click="showMoreParts" class="show-more">
            <span>Показать все главы</span>
          </div>
        </div>

        <!-- <div v-if="imgs">
          <div class="actions">
            <h2 v-if="partIndex !== null" style="margin:40px 0 10px;">
              {{ post.parts[partIndex].title }}
            </h2>
            <button @click="addFav(post.parts[partIndex])" class="dbtn blue">
              Запомнить главу
            </button>
            <button v-if="!showPremiumValue" @click="showPremium" class="dbtn red">
              Убрать рекламу
            </button>
            <button
              v-if="partIndex !== null"
              @click="turnOff"
              class="dbtn green"
            >
              Во весь экран
            </button>
          </div>

          <div style="margin-top:20px;text-align:center;">
            <span v-if="imgsValue >= 1" @click="getImgs(imgsValue - 1)" style="cursor:pointer;margin-right:20px;">
              &larr; Предыдущая глава
            </span>

            <span v-if="post.parts.length - 1 > imgsValue" @click="getImgs(+imgsValue + 1)" style="cursor:pointer;">
              Следующая глава &rarr;
            </span>
          </div>

          <div class="pagination">
            <ul v-if="imgs" :style="'width:' + (imgs.length * 63) + 'px'">
              <li v-for="(img, index) in imgs" :key="`imgs-img-${index}`">
                <span @click="setImg(index)" :class="{ active: index === imgIndex }">{{ index }}</span>
              </li>
            </ul>
          </div>

          <div class="img-loading">
            <i class="loader" />
            <span>Изображение загружается...</span>
          </div>

          <img v-if="img" :src="img" @click="setImg(+imgIndex + 1)" class="imgs">

          <div class="pagination">
            <ul v-if="imgIndex !== null" :style="'width:' + (imgs.length * 63) + 'px'">
              <li v-for="(img, index) in imgs" :key="`imgs-img-second-${index}`">
                <span @click="setImg(index)" :class="{ active: index === imgIndex }">{{ index }}</span>
              </li>
            </ul>
          </div>

          <div style="margin-top:20px;text-align:center;">
            <span v-if="imgsValue >= 1" @click="getImgs(imgsValue - 1)" style="cursor:pointer;margin-right:20px;">
              &larr; Предыдущая глава
            </span>

            <span v-if="post.parts.length - 1 > imgsValue" @click="getImgs(+imgsValue + 1)" style="cursor:pointer;">
              Следующая глава &rarr;
            </span>
          </div>

          <p v-if="isDesktop" class="hint">
            Для вашего удобства изображения можно перелистывать стрелками клавиатуры <strong>"&larr; влево"</strong> и <strong>"вправо &rarr;"</strong>, а так же по клику на само изображение.
            Кнопка <strong>"Запомнить"</strong> добавляет текущую главу в закладки. Последняя прочитанная глава комикса отображается в профиле.
          </p>
        </div> -->
      </div>

      <div v-if="related_anime.length" style="margin:30px 0 30px;">
        <div class="h2">
          Связные аниме
        </div>
        <slider-component :videos="{ items: related_anime, type: 'watch' }" />
      </div>

      <div v-if="updates.length" style="margin:32px 0px;" class="updates-history">
        <h4>Последние обновления комикса</h4>
        <div v-for="item in updates" :key="`updates-${item.date}`">
          <span>{{ item.date | filterDate }}</span>
          <strong>{{ item.update }}</strong>
        </div>
      </div>

      <div>
        <div
          @click="$store.commit('toggleFeedback', true)"
          class="feedback-btn"
          style="margin-top: 20px;"
        >
          <i class="icon-feedback" />
          <span>Возникла проблема?</span>
        </div>
      </div>
    </section>

    <!-- <shopItems :title="post.title" /> -->

    <section v-if="related.length">
      <div class="h2">
        Вам может понравиться
      </div>
      <slider-component :videos="{ items: related, type: 'comics' }" />
    </section>

    <client-only>
      <comments-component :id="`comics-${post.id}`" />
    </client-only>
  </main>
</template>

<script>
import {
  hydrateOnInteraction,
  hydrateWhenIdle,
  hydrateWhenVisible,
} from 'vue-lazy-hydration'
import { mapState } from 'vuex'

export default {
  components: {
    // premiumComponent: hydrateWhenIdle(() => import('~/components/premiumComponent.vue')),
    // adSense: () => import('~/components/adSense.vue'),
    reactionComponent: hydrateWhenIdle(() => import('~/components/reactionComponent.vue')),
    favComponent: hydrateOnInteraction(() => import('~/components/favComponent.vue'), { event: 'click' }),
    shareComponent: () => import('~/components/shareComponent.vue'),
    commentsComponent: hydrateWhenVisible(() => import('~/components/commentsComponent.vue')),
    // shopItems: hydrateWhenVisible(() => import('~/components/shopItems.vue')),
    sliderComponent: hydrateOnInteraction(() => import('~/components/sliderComponent.vue'), { event: 'click' })
  },
  filters: {
    filterDate(val) {
      const value = val
      const months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек'
      ]
      const day =
        new Date(value).getDate() >= 10
          ? new Date(value).getDate()
          : '0' + new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      return `${day} ${months[month]} ${year} в ${hour}:${min}`
    }
  },
  head() {
    const post = this.post
    const title = `${this.q ? `Начните читать ` : ''}${post.category} ${post.title} бесплатно на русском`
    if (post) {
      return {
        title: title,
        link: [
          {
            hid: 'canonical',
            rel: 'canonical',
            href: this.fullPath
          }
        ],
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: `комикс ${post.category.toLowerCase()} ${post.title} на русском`
          },
          {
            hid: 'description',
            name: 'description',
            content: `${this.q ? 'Вы читаете' : 'Читайте'} комикс ${post.category.toLowerCase()} ${post.title} онлайн бесплатно с переводом на русский!`
          },
          {
            hid: 'og:url',
            property: 'og:url',
            content: this.fullPath
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: title
          },
          {
            hid: 'og:description',
            name: 'og:description',
            content: `${this.q ? 'Вы читаете' : 'Читайте'} комикс ${post.category.toLowerCase()} ${post.title} онлайн бесплатно с переводом на русский!`
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: post.poster
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: `${post.category.toLowerCase()} ${post.title}`
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: post.desc
          },
          {
            hid: 'twitter:image',
            property: 'twitter:image',
            content: post.poster
          }
        ]
      }
    }
  },
  watch: {
    turnOffValue(val) {
      if (val) {
        document.documentElement.style.overflow = 'hidden'
        setTimeout(() => {
          const popup = document.querySelector('.popup')
          if (popup) {
            popup.addEventListener('scroll', this.lazyLoadImgs)
          }
        }, 1000)
      } else {
        document.documentElement.style.overflow = ''
        setTimeout(() => {
          const el = document.querySelector('.parts')
          if (el) el.scrollIntoView({ block: 'start', behavior: 'smooth' })
        }, 100)
      }
      this.loadChapter = false
      this.loadChapterLink = ''
    }
    // img() {
    //   this.showAds = false
    //   this.$nextTick(() => {
    //     this.showAds = true
    //   })
    // }
  },
  async asyncData({ $axios, params, error, query }) {
    const id = params.id.includes('-')
      ? params.id.slice(0, params.id.indexOf('-'))
      : params.id
    const { data } = await $axios.get(`/api/comics/${id}`)
    if (data.error) {
      error(data.error)
    } else {
      return {
        q: query.q || '',
        gets: {},
        id,
        imgs: null,
        post: data.post,
        related: data.related,
        related_anime: data.related_anime,
        comics_updates: data.comics_updates,
        updates: data.updates,
        isBlocked: data.blocked,
        turnOffValue: false,
        showComments: false,
        blockI: 0,
        showPremiumValue: false,
        showPartsIndex: 18,
        showAds: true
      }
    }
  },
  computed: {
    ...mapState(['user', 'isDesktop', 'showAdsGlobal']),
    fullPath() {
      return `https://anime777.site/comics/${this.postUrl(this.id, this.post.title)}`
    }
  },
  mounted() {
    document.documentElement.style.overflow = ''
    // window.addEventListener('scroll', this.getQimgs)
    // window.addEventListener('scroll', this.getComments)
    // window.addEventListener('scroll', this.getShopItems)

    const slider = document.querySelector('.slider.comics')
    if (slider) {
      slider.addEventListener('scroll', this.lazyLoadImgs)
    }

    if (!this.user || (this.user && this.user.group !== 777)) {
      const rsyaHorizon = document.createElement('script')
      rsyaHorizon.innerHTML = `
window.yaContextCb.push(()=>{
  Ya.Context.AdvManager.render({
    renderTo: 'yandex_rtb_R-A-1202748-6',
    blockId: 'R-A-1202748-6'
  })
})`
      document.body.appendChild(rsyaHorizon)
    }
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.getQimgs)
    const popup = document.querySelector('.popup')
    if (popup) {
      popup.removeEventListener('scroll', this.lazyLoadImgs)
    }

    const slider = document.querySelector('.slider.comics')
    if (slider) {
      slider.removeEventListener('scroll', this.lazyLoadImgs)
    }
  },
  methods: {
    showMoreParts() {
      this.showPartsIndex = this.post.parts.length
      // this.$nextTick(() => {
      //   const list = document.querySelector('.parts .chapters')
      //   if (list) list.scrollTo(0, list.scrollHeight)
      // })
    },
    getQimgs() {
      const doc = document.documentElement.clientHeight
      const el = document.querySelector('.parts .show-more')
      if (el) {
        const visible = doc - el.getBoundingClientRect().top
        // console.log('animegg', visible)
        if (visible > 0) {
          window.removeEventListener('scroll', this.getQimgs)
          const q = this.q ? this.q : '0'
          this.getImgs(q)
        }
      }
    },
    showPremium() {
      this.showPremiumValue = true
      if (this.turnOffValue) {
        this.turnOff()
      }
      setTimeout(() => {
        const elem = document.querySelector('.premium-status')
        if (elem) elem.scrollIntoView()
      }, 300)
    },
    goToComments() {
      const elem = document.querySelector('.comments')
      if (elem) elem.scrollIntoView()
    },
    async startRead() {
      await this.getImgs('0')
      // this.turnOff()
    },
    turnOff() {
      if (!this.turnOffValue) {
        this.turnOffValue = true
        document.documentElement.style.overflow = 'hidden'
        setTimeout(() => {
          const popup = document.querySelector('.popup')
          if (popup) {
            popup.addEventListener('scroll', this.lazyLoadImgs)
          }
        }, 1000)
      } else {
        this.turnOffValue = false
        document.documentElement.style.overflow = ''
        setTimeout(() => {
          const el = document.querySelector('.actions')
          if (el) el.scrollIntoView({ block: 'start', behavior: 'smooth' })
        }, 100)
      }
    }
  }
}
</script>

<style src="~/assets/comics-id.styl" lang="stylus">
